interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

const Checkbox = ({ checked, onChange, className }: CheckboxProps) => {
  return <input type="checkbox" checked={checked} onChange={() => onChange(!checked)} className={className} />;
};

export default Checkbox;
